import EmployeeTypeTable from "./EmployeeTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const EmployeeType = () => {
  const viewPermission = PERMISSIONS.permission_utilities_employeetype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <EmployeeTypeTable /> : ""}</>
  );
};

export default EmployeeType;
